export default __webpack_public_path__ + "static/media/guesty_lite_step7.5746564b.png";